<template>
  <div class="solution section4">
    <div class="banner">
      <div class="w1200">
        <h3>农产品区域公用品牌数字化解决方案</h3>
        <p>通过“两标一品”，打造优势农产品区域公用品牌</p>
      </div>
    </div>
    <div class="container">
      <h3>中国特色农产品优势区创建认定标准</h3>
      <div class="w1200 sec1"></div>
    </div>
    <div class="d_footer">
      <h3>通过“两标一品”，打造优势农产品区域公用品牌</h3>
      <div class="w1200">
        <div class="img1"></div>
        <div class="img2"></div>
        <div class="img3"></div>
        <ul class="clear">
          <li>
            <p>
              标准化生产。制定标准的种养方案和投入品套餐，帮助农户进行生产决策。
            </p>
          </li>
          <li>
            <p>
              标准化产品。农户按照标准种养方案进行生产，加工企业对产品进行分级，形成标准化产品。
            </p>
          </li>
          <li>
            <p>
              品牌产品。通过对农产品产地的实施标准化种养方案，让农产品数字化，可追溯，依据数据与标准化，联合产地做品牌。
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div class="d_footer1">
      <h3>龙头企业为核心的农业产业化联合体</h3>
      <p>
        鼓励发展以龙头企业为引领，农民合作社和家庭农场跟进，广大小农户参与，采取订单生产、股份合作的农业产业化联合体
      </p>
      <div class="imgSec"></div>
      <ul class="clear">
        <li class="clear">
          <div class="img"></div>
          <p>
            农民将土地入股到合作社，合作社将土地托管给大型龙头企业，龙头企业投入技术及资金，政府出相关配套，聘请职业农民实行专业化经营
          </p>
        </li>
        <li class="clear">
          <div class="img"></div>
          <p>
            实现农民得保底分红、合作社得服务分红、中化农业得运营分红、职业农民得绩效分红，有效促进了小农户与现代农业的有机衔接
          </p>
        </li>
      </ul>
      <div
        class="button"
        @click="
          showDialog = true
          systemId = '3'
        "
      >
        获取最新解决方案
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <dialog-box
      :showDialog="showDialog"
      :systemId="systemId"
      @close="showDialog = false"
    ></dialog-box>
  </div>
</template>
<script>
import dialogBox from './components/dialog'
export default {
  components: {
    dialogBox,
  },
  data() {
    return {
      systemId: '3',
      showDialog: false,
    }
  },
}
</script>

<style lang="scss">
@import '~@/assets/pc/css/solution-4.scss';
</style>
